<template>
  <div id="delivery-form-details-view">
    <div class="grid-row">
      <div class="column">
        <div class="delivery-form-details-view-header">
          <h1>{{$_('delivery_from_details', {delivery_form_id: this.$route.params.delivery_form_id})}}</h1>
        </div>
      </div>
    </div>
    <DeliveryFormDetailsResearch />
    <div class="grid-row">
      <div class="column">
        <DeliveryFormDetailsList />
      </div>
    </div>
    <div class="grid-row">
      <div class="column">
        <DeliveryFormDetailsInfo />
      </div>
    </div>
  </div>
</template>

<script>

import DeliveryFormDetailsList from '@/modules/facture/components/DeliveryFormDetailsList';
import DeliveryFormDetailsResearch from '@/modules/facture/components/DeliveryFormDetailsResearch';
import DeliveryFormDetailsInfo from '@/modules/facture/components/DeliveryFormDetailsInfo';

export default {
  components: {
    DeliveryFormDetailsList,
    DeliveryFormDetailsResearch,
    DeliveryFormDetailsInfo
  }
}
</script>

<style scoped>
</style>